(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/data-attribute-observer/assets/javascripts/data-attribute-observer.js') >= 0) return;  svs.modules.push('/components/components/data-attribute-observer/assets/javascripts/data-attribute-observer.js');
"use strict";

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

svs.components = svs.components || {};
svs.components.dataAttribute = svs.components.dataAttribute || {};
var INTERSECTION_RATIO = 0.5;
var TIME_TO_IMPRESSION = 1000;
var intersectionObserverOptions = {
  root: null,
  rootMargin: '0px',
  threshold: [INTERSECTION_RATIO]
};
var logger = svs.core.log.getLogger('components:data-attribute-observer');
var started = false;
var visualElements = new Set(); 
var attributeMap = new Map(); 

var intersectionObserver;
var mutationObserver;
var isArrayLike = function isArrayLike(obj) {
  return Array.isArray(obj) || Boolean(obj) === true && _typeof(obj) === 'object' && typeof obj.length === 'number' && (obj.length === 0 || obj.length > 0 && obj.length - 1 in obj);
};
var mutationObserverCallback = function mutationObserverCallback(mutationList) {
  mutationList.forEach(function (mutation) {
    if (mutation.type === 'childList' && isArrayLike(mutation.addedNodes)) {
      Array.prototype.forEach.call(mutation.addedNodes, function (node) {
        var _iterator = _createForOfIteratorHelper(attributeMap.keys()),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var attribute = _step.value;
            if (typeof node.hasAttribute === 'function' && node.hasAttribute(attribute)) {
              intersectionObserver.observe(node);
            }
            if (typeof node.querySelectorAll === 'function') {
              var dataImpressionElements = node.querySelectorAll("[".concat(attribute, "]"));
              for (var i = 0; i < dataImpressionElements.length; i++) {
                intersectionObserver.observe(dataImpressionElements[i]);
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }
  });
};
var sendImpression = function sendImpression(element) {
  var _iterator2 = _createForOfIteratorHelper(attributeMap.keys()),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var attribute = _step2.value;
      if (!element.hasAttribute(attribute)) {
        continue;
      }
      var cb = attributeMap.get(attribute);
      cb(element);
      intersectionObserver.unobserve(element);
      var value = element.getAttribute(attribute);
      element.removeAttribute(attribute);
      element.setAttribute("".concat(attribute, "-tracked"), value);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
};
var timeInViewport = function timeInViewport(element) {
  return setTimeout(function () {
    if (visualElements.has(element)) {
      sendImpression(element);
      visualElements.delete(element);
    }
  }, TIME_TO_IMPRESSION);
};
var handleIntersection = function handleIntersection(entries) {
  entries.forEach(function (entry) {
    var el = entry.target;
    if (entry.isIntersecting && entry.intersectionRatio >= INTERSECTION_RATIO) {
      visualElements.add(el);
      timeInViewport(el);
    } else {
      visualElements.delete(el);
    }
  });
};
var updateMutationObserver = function updateMutationObserver() {
  if (mutationObserver) {
    mutationObserver.disconnect();
  }
  var targetNode = document.querySelector('body');
  var mutationObserverOptions = {
    attributes: true,
    attributeFilter: [],
    childList: true,
    subtree: true
  };
  var _iterator3 = _createForOfIteratorHelper(attributeMap.keys()),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var attribute = _step3.value;
      mutationObserverOptions.attributeFilter.push(attribute);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  mutationObserver = new MutationObserver(mutationObserverCallback);
  mutationObserver.observe(targetNode, mutationObserverOptions);
};
var trackAttribute = function trackAttribute(attribute) {
  try {
    var trackedDatasetName = attribute.replace(/^data-/, '');
    trackedDatasetName = trackedDatasetName.replace(/-./g, function (x) {
      return x.toUpperCase()[1];
    }); 
    trackedDatasetName = "".concat(trackedDatasetName, "Tracked");
    var elementsToTrack = _toConsumableArray(document.querySelectorAll("[".concat(attribute, "]")));
    elementsToTrack = elementsToTrack.filter(function (el) {
      return el.dataset[trackedDatasetName] === undefined;
    }); 
    elementsToTrack.forEach(function (el) {
      return intersectionObserver.observe(el);
    });
  } catch (e) {
    logger.warn("Unexpected error:".concat(e.message));
  }
};
var updateImpressionTracking = function updateImpressionTracking() {
  started = true;
  if (intersectionObserver) {
    intersectionObserver.disconnect();
  }
  intersectionObserver = new IntersectionObserver(handleIntersection, intersectionObserverOptions);
  var _iterator4 = _createForOfIteratorHelper(attributeMap.keys()),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var attribute = _step4.value;
      trackAttribute(attribute);
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  updateMutationObserver();
};
svs.components.dataAttribute.track = function (attribute, cb) {
  if (attributeMap.has(attribute)) {
    return;
  }
  attributeMap.set(attribute, cb);
  if (started) {
    updateImpressionTracking();
  }
};
window.addEventListener('load', updateImpressionTracking);

 })(window);